<!--
  * @Author: jh 1758579481@qq.com
  * @Date: 2021/1/13
-->
<template>
    <div>
        <div style="font-size: .32rem;margin: .3rem 0 .15rem 0;font-weight: 700;"><span style="color: red;">*</span>请如实填写此表，看病时交给医生，未填表不能就诊。</div>
        <div>
          <div class="van-cell van-field">
            <div class="van-cell__title van-field__label">
              <span>姓名</span>
            </div>
            <div class="van-cell__value van-field__value">
              <div class="van-field__body">
                <input type="text" name="name" v-model="name" placeholder="患者姓名" class="van-field__control"></input>
              </div>
            </div>
          </div>
          <div class="van-cell van-field">
            <div class="van-cell__title van-field__label">
              <span>住址</span>
            </div>
            <div class="van-cell__value van-field__value">
              <div class="van-field__body">
                <input type="text" name="address" v-model="address" placeholder="住址" class="van-field__control"></input>
              </div>
            </div>
          </div>
          <div class="van-cell van-field">
            <div class="van-cell__title van-field__label">
              <span>身份证号码</span>
            </div>
            <div class="van-cell__value van-field__value">
              <div class="van-field__body">
                <input type="text" name="idCard" v-model="idCard" placeholder="身份证号码" class="van-field__control"></input>
              </div>
            </div>
          </div>
          <div class="van-cell van-field">
            <div class="van-cell__title van-field__label">
              <span>联系电话</span>
            </div>
            <div class="van-cell__value van-field__value">
              <div class="van-field__body">
                <input type="text" name="phone" v-model="phone" placeholder="联系电话" class="van-field__control"></input>
              </div>
            </div>
          </div>
          <div></div>
        </div>
        <div v-for="(item,index) in questions" :key="index" class="question_list">
          <Question :questions="item" :sort="(item.sort+1)" @selectRadio="selectRadio($event,item.sort)"></Question>
          <div v-show="item.sort==6 && showInput">
            <el-input
              style="display: block!important;"
              placeholder="请输入具体地区"
              v-model="formAddress"
              clearable>
            </el-input>
          </div>
        </div>
        <div style="color: red;font-size: .3rem;margin-top: .4rem;text-align: center;">我保证，上述内容属实，否则将承担相应的法律责任。</div>
        <div style="width: 100%;text-align: center;padding-bottom: 1rem;">
          <el-button type="success" round size="medium" style="width: 80%;font-size: .3rem;color: #ffffff;" @click="subForm">确定</el-button>
        </div>
    </div>
</template>

<script>
  import {Savehiscrownresult, getPatientInfo, yyguahao} from '../../api'
  import Question from "../common/Question";
    export default {
        name: "questionnaire1",
        components:{
          Question
        },
        data() {
            return {
              questions:[
                {sort:0,question:'你是否有发热、咳嗽等呼吸道症状？',result:'是;否'},
                {sort:1,question:'近21天是否去过国外、港澳台或其他国内重点地区，或有病例报告的社区？',result:'是;否'},
                {sort:2,question:'近21天内是否接触过来自国外、港澳台或其他国内重点地区的发热或有呼吸道症状的患者？',result:'是;否'},
                {sort:3,question:'近21天内是否与新型冠状病毒感染者（核酸检测阳性者）有接触？',result:'是;否'},
                {sort:4,question:'近21天内您的家庭或办公室等小范围内是否出现2例及以上发热和/或呼吸道症状的病例？',result:'是;否'},
                {sort:5,question:'粤康码',result:'绿码;红码;无法提供'},
                {sort:6,question:'您21天内从哪个地区来蕉岭？',result:'一直在蕉岭;国内（请在下方注明具体省市县）;香港;澳门;台湾;国外（请在下方注明具体国家或地区）'},
              ],
              name:'',
              address:'',
              idCard:'',
              phone:'',
              results:[],
              formAddress:'',
              showInput:false,
              orderId:''
            }
        },
        created() {
          //修改标题
          document.title = '新冠肺炎流行病学史问卷'
          getPatientInfo({
            strid:this.$storage.get('patient').id
          }).then(res=>{
            this.name = res.clinic_patient_name
            this.address = res.address
            this.idCard = res.idCard
            this.phone = res.phone
          })
        },
        methods: {
          selectRadio(item, id) {
            if (id == 6) {
              if (item == '国内（请在下方注明具体省市县）' || item == '国外（请在下方注明具体国家或地区）') {
                this.showInput = true
              } else {
                this.showInput = false
              }
            }
            if (this.results.length > 0) {  //判断结果是否为空
              let find = this.results.findIndex((v) => {
                return v.pid == id
              })
              if (find > -1) {  //判断结果里是否有相同的id
                this.results = this.results.map(m => {
                  return m.pid == id ? {pid: id, question: this.questions[id].question, result: item } : m
                })   //覆盖掉id相同的那条数据
              } else {
                this.results.push({pid: id, question: this.questions[id].question, result: item})
              }
            } else {
              this.results.push({pid: id, question: this.questions[id].question, result: item})
            }
          },
          subForm() {
            if(!this.name){
              this.$message({
                message: '请填写您的姓名！',
                type: 'error',
                duration:3000,
                center:true,
                offset:200
              });
              return
            }
            if(!this.address){
              this.$message({
                message: '请填写您的住址！',
                type: 'error',
                duration:3000,
                center:true,
                offset:200
              });
              return
            }
            let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            if(!reg.test(this.idCard)){
              this.$message({
                message: '请将您的身份证号码填写完整！',
                type: 'error',
                duration:3000,
                center:true,
                offset:200
              });
              return
            }
            if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone))){
              this.$message({
                message: '请填写您的联系电话！',
                type: 'error',
                duration:3000,
                center:true,
                offset:200
              });
              return
            }
            if(this.results.length != 7){
              this.$message({
                message: '请将问卷填写完整！',
                type: 'error',
                duration:3000,
                center:true,
                offset:200
              });
              return
            }
            if(!this.formAddress && this.showInput){
              this.$message({
                message: '请填写具体地区！',
                type: 'error',
                duration:3000,
                center:true,
                offset:200
              });
              return
            }
            let myDate = new Date()
            let yy = myDate.getFullYear();
            let mm = String((myDate.getMonth() + 1) < 10 ? '0' + (myDate.getMonth() + 1) : (myDate.getMonth() + 1))
            let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate())
            Savehiscrownresult({
              createtime:yy+mm+dd,
              patient_id: this.$storage.get('patient').patient_id,
              name:this.name,
              address:this.address,
              idCard:this.idCard,
              phone:this.phone,
              result:this.results,
              formAddress: this.formAddress,
              openid:this.$storage.get('openid')
            }).then(res=>{
              if(res.IsSuccess){
                if(this.$route.query.money==0){
                  this.pay()
                  return;
                }
                this.$router.push({path:'/payment',query:{
                    money:this.$route.query.money,
                    ksId:this.$route.query.ksId,
                    ks:this.$route.query.ks,
                    doctor:this.$route.query.doctor,
                    doctorId:this.$route.query.doctorId,
                    date:this.$route.query.date,
                    dated:this.$route.query.dated,
                    hyxlh:this.$route.query.hyxlh,
                    pbxlh:this.$route.query.pbxlh,
                  }})
              }else {
                this.$message({
                  message: '出错啦，请重试！',
                  type: 'error',
                  duration:3000,
                  center:true,
                  offset:200
                });
              }
            })
          },
          pay(){
            let patient = this.$storage.get('patient')
            let query = this.$route.query
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            yyguahao({
              birthday:patient.birth
            },{
              order_id: this.orderId,
              amount: query.money,
              // cancle_msg: "string",
              clinic_card_num: patient.clinic_num,
              clinic_patient_name: patient.clinic_patient_name,
              // create_time: "2020-07-07T03:03:46.578Z",
              dept_id: query.ksId,
              dept_name: query.ks,
              // discount: "string",
              doc_id: query.doctorId,
              doc_name: query.doctor,
              // his_serial_num: "string",
              num_source_date: query.date,
              num_source_serial_num: query.hyxlh,
              // pay_status: 0,
              // pay_time: "2020-07-07T03:03:46.578Z",
              price: query.money,
              schedule_serial_num: query.pbxlh,
              // status: 0,
              time_period: query.dated,
              // update_time: "2020-07-07T03:03:46.578Z",
              user_open_id: patient.open_id,
              HealthCardId: patient.healthCardId,
              PatientId: patient.patient_id,
              unionid:this.$storage.get('unionid'),
              // transaction_id: "string",
              // his_returncode: "string",
              // his_returnmsg: "string",
              // refund_status: "string"
            }).then(res=>{
              if(!res.IsSuccess){
                this.$message({
                  message: res.Msg,
                  type: 'error',
                  duration:3000,
                  center:true,
                  offset:200
                });
              }else {
                loading.close();
                this.$message({
                  message: '预约成功！',
                  type: 'success',
                  duration:3000,
                  center:true,
                  offset:200
                });
                setTimeout(() => {
                  this.$router.push({path:'/registrationRecord'})
                }, 500)
              }
            })
          }
        }
    }
</script>

<style scoped>
  @import "../../../static/css/vant.css";
  .question_list{
    width: 90%;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/questionnaire1.vue